module.exports = __webpack_public_path__ + "static/the-art-of-fielding-d661f17181e50f3854a2fbc688cf50a1.jpg";